import { render, staticRenderFns } from "./ReportPmtaRelays.vue?vue&type=template&id=4bf7c502&scoped=true"
import script from "./ReportPmtaRelays.vue?vue&type=script&lang=js"
export * from "./ReportPmtaRelays.vue?vue&type=script&lang=js"
import style0 from "./ReportPmtaRelays.vue?vue&type=style&index=0&id=4bf7c502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf7c502",
  null
  
)

export default component.exports